var _rect, _path, _path2, _circle, _path3, _rect2, _path4, _rect3, _path5, _rect4, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotationImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 96,
    viewBox: "0 0 109 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 11,
    width: 5,
    height: 5,
    fill: "#FF8646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 6.5H101V79.5H64.5L61.5 87L108.5 88V6.5Z",
    fill: "#005B7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 1V58C45.5 58 50 61 55.5 68C61 75 65.5 79.5 65.5 79.5H101V1H45.5Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 76.5,
    r: 18.5,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 14H93.5",
    stroke: "#005B7F",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 21,
    width: 5,
    height: 5,
    fill: "#FF8646"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 24H93.5",
    stroke: "#005B7F",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 31,
    width: 5,
    height: 5,
    fill: "#FF8646"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 34H93.5",
    stroke: "#005B7F",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 41,
    width: 5,
    height: 5,
    fill: "#FF8646"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 44H93.5",
    stroke: "#005B7F",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 65H25M7 77H21M13 89.5H24",
    stroke: "#FF8646",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 63V77L50.5 83",
    stroke: "#FF8646",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationImg);
export default __webpack_public_path__ + "static/media/quotationIMG.05bcf556a86e9165d530807d79078d9f.svg";
export { ForwardRef as ReactComponent };